import Service from '@/service/index.js';

// 获取图片验证码
const getCodeImage = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Service.getCodeImage().then(response => {
      commit('SET_CAPTCHA_IMAGE', response);
    }, error => {
      reject(error.data);
    });
  });
};

// 账号密码登录
const loginSystem = ({}, params) => {
  return new Promise((resolve, reject) => {
    Service.loginSystem(params).then(response => {
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};

// 获取短信验证码
const getSmsCode = ({}, postData) => {
  return new Promise((resolve, reject) => {
    Service.getSmsCode(postData).then(response => {
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};

// 获取短信验证码 登录的时候
const getSmsCodeSign = ({}, postData) => {
  return new Promise((resolve, reject) => {
    Service.getSmsCodeSign(postData).then(response => {
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};

// 短信验证码登录
const loginSystemByMobile = ({}, postData) => {
  return new Promise((resolve, reject) => {
    Service.loginSystemByMobile(postData).then(response => {
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};

export const actions = {
  getCodeImage,
  loginSystem,
  getSmsCode,
  getSmsCodeSign,
  loginSystemByMobile
};
